import { AxiosPromise } from "axios";
import {AppResourceApi, GoogleMember, InitDto, LoginDto, LoginResponse} from "../generated/account-client";
import { accountApiConfig, ops } from "./config";

const api = new AppResourceApi(accountApiConfig);

const AppApi = {
  init(loginToken: string = ""): AxiosPromise<InitDto> {
    return api.init(ops(loginToken));
  },

  getGoogleMember(token: string): AxiosPromise<GoogleMember> {
    return api.googleLogin(token);
  },

  checkEmail(email: string): AxiosPromise<boolean> {
    return api.checkEmail(email, ops());
  },

  login(dto: LoginDto): AxiosPromise<LoginResponse> {
    return api.login(dto);
  }
};

export default AppApi;
